import React from "react";
import { Wrench, Globe, Star } from "lucide-react"; // Importa íconos de Lucide
import trabajadorImg from "../assets/images/nosotros/5.png"; // Imagen del trabajador

const Distincion = () => {
  const items = [
    { icon: <Wrench />, text: "EXPERIENCIA DESDE 1984" },
    { icon: <Globe />, text: "COBERTURA A NIVEL NACIONAL E INTERNACIONAL" },
    { icon: <Star />, text: "MEJORES SERVICIOS PERSONALIZADOS" },
  ];

  return (
    <section className="container mx-auto px-6 py-12">
      {/* Título */}
      <h2 className="text-center text-xl font-bold text-gris-oscuro">
        QUE NOS DISTINGUE
      </h2>
      <div className="w-16 h-1 bg-azul mx-auto mt-2"></div>

      {/* Contenido */}
      <div className="flex flex-col md:flex-row items-center mt-10">
        {/* Imagen */}
        <div className="w-full md:w-1/2 flex justify-center">
          <img src={trabajadorImg} alt="Trabajador" className="max-h-96 object-contain" />
        </div>

        {/* Texto e íconos */}
        <div className="w-full md:w-1/2 text-gris-oscuro px-6">
          <h3 className="text-lg font-semibold mb-4">POR QUÉ ELEGIRNOS</h3>
          <p className="text-sm mb-4">
            Nuestro principal valor viene de nuestra gente. Estamos orgullosos de contar con
            un equipo altamente capacitado, experimentado y certificado. Con alcance internacional,
            estamos seguros de afrontar cualquier desafío con éxito.
          </p>

          {/* Lista de beneficios */}
          <ul>
            {items.map((item, index) => (
              <li key={index} className="flex items-center mb-3">
                <div className="w-10 h-10 bg-azul-oscuro text-blanco flex items-center justify-center rounded-md transition-transform hover:scale-110">
                  {item.icon}
                </div>
                <span className="ml-4 font-medium">{item.text}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};

export default Distincion;
